export default __webpack_public_path__ + "f3304ecc4a2c448b19339c3b925a8f42.png";